import { render, staticRenderFns } from "./__2FAVerification.vue?vue&type=template&id=4134fe06"
import script from "./__2FAVerification.vue?vue&type=script&lang=js"
export * from "./__2FAVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports